import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UseQueryResult } from 'react-query';

import { Dialog, DialogProps } from 'components';
import { TranslationNamespace } from 'i18n';
import { OrderSciEvent } from 'types';

import { SciEventsTable } from './SciEventsTable';

type Props = {
  queryResult: UseQueryResult<OrderSciEvent[]>;
} & DialogProps;

export const SciEventsDialog: React.FC<Props> = ({
  queryResult,
  open,
  onClose,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.sci_events',
  });

  return (
    <Dialog
      title={t('title')}
      open={open}
      modal
      maxWidth="md"
      onClose={onClose}
    >
      <Alert severity="warning" sx={{ mb: 4 }}>
        {t('dialog.retention_notice')}
      </Alert>
      <SciEventsTable queryResult={queryResult} />
    </Dialog>
  );
};
